import { POLONIA_CREST as logoUrl } from './clubIdentity';
import { useState } from 'react';
import { savePublicKey, supabaseProjectUrl } from './supabase';
import { useI18n } from './I18nContext';

export function ConnectionScreen({ onConnected }: { onConnected: () => void }) {
  const { t } = useI18n();
  const [key, setKey] = useState('');

  return (
    <div className="auth-stage">
      <section className="metal-card auth-card">
        <img className="auth-logo" src={logoUrl} alt="" />
        <p className="eyebrow">ELITE COACH CLOUD 2.0</p>
        <h1>{t.connectTitle}</h1>
        <label>Supabase Project</label>
        <input value={supabaseProjectUrl} disabled />
        <label>{t.publicKey}</label>
        <textarea value={key} onChange={(e) => setKey(e.target.value)} />
        <button
          onClick={() => {
            if (!key.trim()) return;
            savePublicKey(key);
            onConnected();
          }}
        >
          {t.connect}
        </button>
      </section>
    </div>
  );
}
